/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PharmacyCounselorPublicCrowdStatus,
  PharmacyCounselorPublicCrowdStatusFromJSON,
  PharmacyCounselorPublicCrowdStatusToJSON,
} from "../models";

export interface GetCrowdStatusRequest {
  pharmacyId: Array<number>;
}

/**
 *
 */
export class CounselingCrowdStatusApi extends runtime.BaseAPI {
  /**
   * No authentication required, returns publicly available information
   */
  async getCrowdStatusRaw(
    requestParameters: GetCrowdStatusRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<Array<PharmacyCounselorPublicCrowdStatus>>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling getCrowdStatus."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.pharmacyId) {
      queryParameters["pharmacy_id"] = requestParameters.pharmacyId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/crowd-status`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(PharmacyCounselorPublicCrowdStatusFromJSON)
    );
  }

  /**
   * No authentication required, returns publicly available information
   */
  async getCrowdStatus(
    requestParameters: GetCrowdStatusRequest,
    initOverrides?: RequestInit
  ): Promise<Array<PharmacyCounselorPublicCrowdStatus>> {
    return promiseRetry(
      (retry) =>
        this.getCrowdStatusRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
